module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--3-9be97379.png";